import { createPinia } from 'pinia';
import type { UserModule } from '../types';

export const install: UserModule = ({ initialState, app, router }) => {
    const pinia = createPinia();
    app.use(pinia);
    if (import.meta.env.SSR) {
        initialState.pinia = pinia.state.value;
    } else {
        pinia.state.value = initialState?.pinia || {};
    }
    const session = useSessionStore();
    router.beforeEach(async (to) => {
        if (to.meta.requiresAdmin) {
            await session.init();
            if (!session.sessionContext.isAdminOrSupport) {
                router.replace('/');
                return;
            }
        }
    });
};
